export default {
  "and": "y",
  "Back": "Atrás",
  "Click to Expand": "Clic para Ampliar",
  "Click to Hide": "Clic para Ocultar",
  "Click to Highlight": "Clic para Resaltar",
  "Click to Show": "Clic para Mostrar",
  "Click to Show All": "Clic para Mostrar Todo",
  "Download": "Descargar",
  "Loading Visualization": "Cargando Visualización",
  "more": "más",
  "No Data Available": "Datos No Disponibles",
  "Powered by D3plus": "Funciona con D3plus",
  "Share": "Porcentaje",
  "Shift+Click to Hide": "Mayús+Clic para Ocultar",
  "Shift+Click to Highlight": "Mayús+Clic para Resaltar",
  "Total": "Total",
  "Values": "Valores"
};